// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2199) return "static/chunks/2199-a3d9ae25c0b9106e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","1177":"a2f8931e7991f044","4316":"da7517a88118b074","6457":"aee163ff2aa3e78c","8854":"aff34e30b5de1a3a","9626":"866c182d50955941"}[chunkId] + ".js";
};